// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumbs_breadcrumb__KySjf","active":"Breadcrumbs_active__y9-gj","breadcrumbs":"Breadcrumbs_breadcrumbs__blNCd"};